import React, { FC, useMemo } from 'react';
import { ProductCards as UIProductCards } from '@raisin/components-lib';
import { useFeatureFlag } from '@raisin/cp-utils';
import { useT } from '@transifex/react';
import { ProductCardsContentProps } from './types';
import { createProductCardsParser } from './utils/createProductCardsParser';

const ProductCardsContent: FC<ProductCardsContentProps> = ({
  linkGenerator,
  onPaginationClick,
  onProductClick,
  ...props
}) => {
  const t = useT();
  const { variation } = useFeatureFlag();

  const featureFlags = useMemo(
    () => ({
      isAutoProductLabelEnabled: variation?.('b2cProductCardLabel', false),
    }),
    [variation],
  );

  const parser = useMemo(
    () =>
      createProductCardsParser({
        formatMessage: t,
        linkGenerator,
        locale: props.locale,
        featureFlags,
      }),
    [t, props.locale, linkGenerator, featureFlags],
  );

  const cards = useMemo(() => parser(props), [props, parser]);

  return (
    <UIProductCards
      testId={`${props.testId ?? ''}${props.uid}`}
      {...cards}
      {...{ onPaginationClick, onProductClick }}
    />
  );
};
export default ProductCardsContent;
